import classnames from "classnames";

import { Icon } from "@seneca/senekit";

import styles from "./CloseIcon.module.scss";

type Props = {
  onClick?: () => void;
  wrapperClassName?: string;
};

const CloseIcon = (props: Props) => {
  const { wrapperClassName, onClick } = props;
  return (
    <div
      className={classnames(styles.wrapper, wrapperClassName)}
      onClick={onClick}
    >
      <Icon iconName="cross" tone="neutral" accessibilityLabel="Close" />
    </div>
  );
};

export default CloseIcon;
